import {
  type SanitySortOption,
  type SanitySortOptionType,
} from '@data/sanity/queries/types/cart'
import { type UpdateUrlParameters } from '@lib/hooks'
import { StringsContext } from '@lib/strings-context'

import CollectionListbox from './listbox'
import { useContext } from 'react'

interface CollectionSortProps {
  sortOptions: SanitySortOption[]
  activeSortValue: SanitySortOptionType | null
  updateParameters: UpdateUrlParameters
}

const CollectionSort = ({
  sortOptions,
  activeSortValue,
  updateParameters,
}: CollectionSortProps) => {
  const strings = useContext(StringsContext)

  return (
    <CollectionListbox
      id="collection-sort"
      name="sort"
      label={strings.collectionSortDescription}
      options={sortOptions}
      activeOption={activeSortValue}
      updateParameters={updateParameters}
      before={`${strings.collectionSortLabel}: `}
    />
  )
}

export default CollectionSort
